import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import HomeBarButton from '@core/dashboard/components/HomeBarButton';
import { useAssistant } from '@core/assistant/providers/Provider';
import { VirtualAssistantIcon } from './VirtualAssistantIcon';
import { useStyles } from './styles';
import { log } from '../providers/Debug';

const Button = ({ isLargeButton }: { isLargeButton?: boolean }) => {
  const { setOpen, isAIEnabledForEvent, startFlow, scripts } = useAssistant();
  const classes = useStyles(isLargeButton);
  const { enqueueSnackbar } = useSnackbar();
  const { t: translate } = useTranslation();

  useEffect(() => {
    log('scripts', scripts);

    if (!scripts?.length) {
      return;
    }

    if (isAIEnabledForEvent()) {
      setTimeout(() => {
        setOpen(true);
      }, 0);
      startFlow('landing');
    }
  }, [scripts]);

  return (
    <HomeBarButton
      sx={classes.homeBarButton}
      label={'Noa Assistant'}
      icon={<VirtualAssistantIcon isLargeButton={isLargeButton} />}
      handleClick={() => {
        if (!isAIEnabledForEvent()) {
          enqueueSnackbar(translate('assistant.disabledMessage'), {
            variant: 'warning',
            preventDuplicate: true,
          });
          return;
        }
        setOpen((prevState) => !prevState);
      }}
    />
  );
};

export default Button;
